var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.taskHasWarnings)?_c('v-icon',{staticClass:"task-warning",attrs:{"small":_vm.small,"large":_vm.large,"x-large":_vm.xLarge,"x-small":_vm.xSmall,"color":_vm.warningcolour}},[_vm._v("mdi-alert")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }